import React from "react";

const overlayStyle = {
  position: "fixed",
  inset: 0,
  background: "rgba(0,0,0,0.75)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 2000,
  padding: 20,
};

const viewerStyle = {
  width: "90%",
  maxWidth: 1100,
  height: "90vh",
  background: "#fff",
  borderRadius: 8,
  padding: 12,
  boxShadow: "0 12px 40px rgba(2,6,23,0.6)",
  display: "flex",
  flexDirection: "column",
};

const iframeStyle = {
  flex: 1,
  width: "100%",
  border: "none",
  userSelect: "none",
  pointerEvents: "auto",
};

const PdfModalViewer = ({ fileUrl, onClose }) => {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={viewerStyle} onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <strong>PDF Viewer</strong>
          <button
            onClick={onClose}
            style={{
              background: "#ef4444",
              color: "#fff",
              border: "none",
              padding: "6px 10px",
              borderRadius: 6,
              cursor: "pointer",
            }}
          >
            Close
          </button>
        </div>

    <iframe
  title="PDF Viewer"
  src={`${fileUrl}#toolbar=0&navpanes=0&scrollbar=0`}
  style={iframeStyle}
></iframe>


        <small style={{ marginTop: 8, opacity: 0.6 }}>
          Read-only mode – download, print, copy disabled.
        </small>
      </div>
    </div>
  );
};

export default PdfModalViewer;
